import { ComponentFactoryResolver, Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatInputModule } from '@angular/material/input';
import { MatSlider, MatSliderModule } from '@angular/material/slider';

import { SgInputSliderComponent } from './input-slider.component';

@NgModule({
  declarations: [SgInputSliderComponent],
  imports: [CommonModule, MatSliderModule, MatInputModule],
  exports: [SgInputSliderComponent],
})
export class SgInputSliderModule {
  constructor(cf: ComponentFactoryResolver, injector: Injector) {
    // this is a workaround to ensure CSS from mat slider is loaded, otherwise it is omitted.
    cf.resolveComponentFactory(MatSlider).create(injector);
  }
}
